import React from 'react';

const formatDate = (dateString, locale) => {
    try {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) return "Invalid date"; // Handle invalid dates

    return date.toLocaleString(locale, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
    });
    } catch (error) {
        return "Invalid date";
    }
};

export const DateDisplay = ({ datetime }) => {

    const userLocale = navigator.language || "en-US";

    return (
            <span>{formatDate(datetime, userLocale)}</span>
    );
};
